'use strict';
var $ = require('jquery');
var ajaxHandler = require('shared/scripts/modules/services/ajaxHandler');
var store = require('../utils/store');

//const
var cacheKey = 'intlGroupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getSchemeInfo(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        if (groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: process.env.contextRoot + '/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: process.env.contextRoot + '/rest/scheme'})
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        }
        return fetchInProgress;
    }
}
module.exports.getSchemeInfo = getSchemeInfo;
module.exports.getContactInformation = getContactInformation;


//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/services/internationalSchemeService.js
// module id = lQbp
// module chunks = 0 1 2 3 4 5 6 7 8